import axios from 'axios';
import { getCsrftoken } from '../../../helpers/csfrToken';
import { RestApiState } from '../../../interfaces/Rest/types';
import { WifiSettingsProps } from '../../../interfaces/AccumulatorWifi/types';
import { restErrorHandler } from '../../../helpers/restErrorHandler';


export const updateWifiSettings = (serialNumber: string, role: string, data: WifiSettingsProps, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<WifiSettingsProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-wifi-settings`, data , headers)
        .then(response => {
                if (response.status === 201) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}

export const fetchWifiData = (serialNumber:string, role: string, setData: (value:any) => void):void => {
    axios.get<WifiSettingsProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/update-wifi-settings`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: WifiSettingsProps = response.data
            setData(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}